import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import consumer1 from "../images/mainconsu.jpeg";
import consumer2 from "../images/mainconsu.jpeg";
import consumer3 from "../images/down3.jpg";
import professional1 from "../images/mainpro.jpeg";
import professional2 from "../images/flood2.jpg";
import professional3 from "../images/solar-street.jpg";
import pcb1 from "../images/mainpc.jpg";
import pcb2 from "../images/mainpc.jpg";
import pcb3 from "../images/mainpc.jpg";
import AOS from "aos";
import "aos/dist/aos.css";

function HomeProducts() {
  const [consumerIndex, setConsumerIndex] = useState(0);
  const [professionalIndex, setProfessionalIndex] = useState(0);
  const [pcbIndex, setPcbIndex] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 1000, offset: 200, once: true });
  }, []);

  return (
    <Container fluid className="home-products p-0">
      {/* Consumer Section */}
      <Row className="align-items-center consumer-section mt-5" data-aos="fade-right">
        <Col md={7} className="image-container">
          <img src={[consumer1, consumer2, consumer3][consumerIndex]} alt="Consumer" className="background-image" />
          {/* <div className="image-controls">
            <FaArrowLeft className="icon-btn left" onClick={() => setConsumerIndex((prev) => (prev - 1 + 3) % 3)} />
            <FaArrowRight className="icon-btn right" onClick={() => setConsumerIndex((prev) => (prev + 1) % 3)} />
          </div> */}
        </Col>
        <Col md={5} className="card-container">
          <div className="dots-overlay"></div>
          <Card className="glass-card shadow-effect">
           <Card.Body>
            <h2 className="title">
              <a href="/consumer-product" className="title">
                Consumer
              </a>
            </h2>
            <p className="description">
              Explore our premium range of products specifically crafted for consumers. And light up your life and houses, offices with our exclusive range of products.
            </p>
          </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Professional Section */}
      <Row className="align-items-center professional-section" data-aos="fade-left">
        <Col md={5} className="card-container professional-card order-1">
          <div className="dots-overlay"></div>
          <Card className="glass-card shadow-effect professional-card">
            <Card.Body>
              <h2 className="title">
                 <a href="/professional-product" className="title">
               Professional
              </a>
                </h2>
              <p className="description">
              We are specialised in professional lighting segment and with great craftsmanship we have designed high-end products to enhance the whole lighting experience and brighten up the world with products that add value to our lives.
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={7} className="image-container order-2">
          <img src={[professional1, professional2, professional3][professionalIndex]} alt="Professional" className="background-image" />
          {/* <div className="image-controls">
            <FaArrowLeft className="icon-btn left" onClick={() => setProfessionalIndex((prev) => (prev - 1 + 3) % 3)} />
            <FaArrowRight className="icon-btn right" onClick={() => setProfessionalIndex((prev) => (prev + 1) % 3)} />
          </div> */}
        </Col>
      </Row>

      {/* PCB Section */}
      <Row className="align-items-center pcb-section" data-aos="fade-right">
        <Col md={7} className="image-container">
          <img src={[pcb1, pcb2, pcb3][pcbIndex]} alt="PCB" className="background-image" />
          {/* <div className="image-controls">
            <FaArrowLeft className="icon-btn left" onClick={() => setPcbIndex((prev) => (prev - 1 + 3) % 3)} />
            <FaArrowRight className="icon-btn right" onClick={() => setPcbIndex((prev) => (prev + 1) % 3)} />
          </div> */}
        </Col>
        <Col md={5} className="card-container">
          <div className="dots-overlay"></div>
          <Card className="glass-card shadow-effect">
            <Card.Body>
              <h2 className="title"> <a href="/Ourproduct" className="title">
               PCB
              </a></h2>
              <p className="description">
              Power Your Innovations with High Quality, Precision Engineered PCB Boards Reliable, Customizable, and Built for Performance!
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default HomeProducts;
